import { render, staticRenderFns } from "./SearchByVideoFaceView.vue?vue&type=template&id=6eb54482"
import script from "./SearchByVideoFaceView.vue?vue&type=script&lang=js"
export * from "./SearchByVideoFaceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports